import API from '../api-service';

const baseUri = 'session';

export default {
  createSession(body, standard) {
    return API.post(`${baseUri}/${standard}`, body);
  },
  getProgress(standard) {
    const sessionId = localStorage.getItem('session');
    return API.get(`${baseUri}/${standard}/${sessionId}/track`);
  },
  saveProgress(body, standard) {
    const sessionId = localStorage.getItem('session');
    return API.post(`${baseUri}/${standard}/${sessionId}/track`, body);
  },
  exitSession(standard) {
    const sessionId = localStorage.getItem('session');
    return API.post(`${baseUri}/${standard}/${sessionId}/exit`);
  },
};
